import {
  Component,
  OnInit
} from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { map } from "rxjs/operators";
import { ContentManager } from "src/app/core/helpers/content-manager/content-manager";
import { HandAccesibility } from "src/app/core/helpers/hand-accesibility/hand-accesibility";
import { IAffiliatesProcess } from "src/app/core/models/affiliation/iaffiliate-process";
import { IContribuyente } from "src/app/core/models/business-information/ibusiness-information";
import { IContentManager } from "src/app/core/models/content-manager/icontent-manager";
import { FormatDocumentTypePipe } from "src/app/core/pipes/format-documant-type/format-document-type.pipe";
import { AffiliationService } from "src/app/core/services/affiliation/affiliation.service";
import { CompanyService } from "src/app/core/services/company/company.service";
import { ContentManagerService } from "src/app/core/services/content-manager/content-manager.service";
import { GlobalService } from "src/app/core/services/global/global.service";
import { ModalService } from "src/app/core/services/modal/modal.service";
import { NotificationService } from "src/app/core/services/notification/notification.service";
import { RequestService } from "src/app/core/services/request/request.service";
import { environment } from "../../../../../environments/environment";
import { RoutingPath } from "./../../../../configs/routing-path";
import { IUser } from "./../../../../core/models/user/user";
import { LocalStorageService } from "./../../../../core/services/local-storage/local-storage.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  public loadingTop = false;
  public afiliarTraba;
  public afiliarMas;
  public trabajadores;
  public certificados;
  public userloggedin: IUser;
  public infoContentManager: Array<IContentManager>;
  public pInfo: IContentManager;
  public pWelcome: IContentManager;
  public txtWelcome = "";
  public companyData: IContribuyente;
  public idModal = "infoImportant";
  public showInfoImportant: boolean;
  public panelOpenState: boolean = false;
  public urlEncuesta;
  infoImportant: IContentManager;
  solicitudes: IAffiliatesProcess[] = [];
  loading: boolean = true;
  public business: IContribuyente;
  loadingDetail: boolean[] = [];

  constructor(
    private _storage: LocalStorageService,
    private contentManagerService: ContentManagerService,
    private _company: CompanyService,
    private title: Title,
    private router: Router,
    private _modal: ModalService,
    private notificationService: NotificationService,
    private formatDocumentTypePipe: FormatDocumentTypePipe,
    public requestService: RequestService,
    private globalService: GlobalService,
    private multiSolicitudService: AffiliationService,
    private affiliationService: AffiliationService,
    private _ROUTER: Router,
    private _STORAGE: LocalStorageService,
  ) {}
  ngOnInit() {
    this.business = this._storage.parseItem('businessInformation');
    this.urlEncuesta = "https://colsubsidio.az1.qualtrics.com/jfe/form/SV_cLQaT3LecKFsQmO"
    this.title.setTitle(
      HandAccesibility.TitlePages.filter((a) => a.page === this.router.url)[0]
        .title
    );

    this.getAllItemsManagerContent();
    this.globalService.getSalarioMinimo();
    this.afiliarTraba =
      RoutingPath.appRouting.components.invidivual_affiliation.path +
      "/" +
      RoutingPath.appRouting.components.invidivual_affiliation.pages.home.path;
    this.afiliarMas =
      RoutingPath.appRouting.components.mass_affiliation.path +
      "/" +
      RoutingPath.appRouting.components.mass_affiliation.pages.home.path;
    this.trabajadores =
      RoutingPath.appRouting.components.workers_information.path +
      "/" +
      RoutingPath.appRouting.components.workers_information.pages.consult_worker
        .path;
    this.certificados =
      RoutingPath.appRouting.components.certificates.path +
      "/" +
      RoutingPath.appRouting.components.certificates.pages.consult_worker.path;

    this.userloggedin = this._storage.getItemJSON(environment.LOCAL_STORAGE.USER_LOGGED_IN);
    this.infoContentManager = ContentManager.contentExtraction(
      this._storage.getItemJSON(environment.LOCAL_STORAGE.GESTOR_CONTENIDO),
      "dashboard",
      "home"
    );
    this.fillPInfoPWelcome();
    this.companyData = this._storage.getItemJSON(
      environment.LOCAL_STORAGE.BUSINESS_INFORMATION
    );
    if (this.companyData === undefined || this.companyData === null) {
      this.getBusinnessInformation();
    }
    this.showInfoImportant = (this.infoImportant?.secondary_text.length > 0);

    if (this.business !== null) {
      const docType = `${this.formatDocumentTypePipe.transform(
        this.business.tipoDocumento
      )}`;
      const docNumber = `${this.business.numeroDocumento}`;
      const state = `2`;
      const isRectificable = true;

      this.notificationService
        .getCreditsRequestNotifyBusiness(
          docType,
          docNumber,
          state,
          isRectificable
        )
        .pipe(
          map((res) => {
            this._storage.stringifyItem(
              environment.LOCAL_STORAGE.BUSINESS_NOTIFICATION_INFORMATION,
              res.body
            );
          })
        )
        .subscribe((data) => {});
      this.showInfoImportant =
        this.infoImportant.secondary_text.length > 0 ? true : false;
    }
    this.loadSolicitudes();
  }

  getBusinnessInformation() {
    this._company.getBusinnessInformationObs().subscribe((dataCompany) => {
      this.companyData = dataCompany;
    });
  }

  getAllItemsManagerContent() {
    this.contentManagerService.getAllItems().subscribe();
  }

  fillPInfoPWelcome() {
    this.infoContentManager.forEach((val) => {
      if (val.field === "paragraphInfo") {
        this.pInfo = val;
      }
      if (val.field === "paragraphWelcome") {
        this.pWelcome = val;
      }
      if (val.field === "infoImportant") {
        this.infoImportant = val;
      }
    });

    this.txtWelcome = this.pWelcome?.text.replace(
      "{usuario}",
      this.userloggedin.firstName
    );
  }

  ngAfterViewInit() {
    let infoShow = this._storage.getItemString("infoShow");
    if (infoShow == null || infoShow == "false") {
      this.openPopupInfoImportant();
    }
  }
  openPopupInfoImportant() {
    if (this.showInfoImportant) {
      this._modal.openModal(this.idModal);
      this._storage.setItem("infoShow", true);
    }
  }

  loadSolicitudes(): void {
    
    this.multiSolicitudService.getSolicitudesByEmpresa(this.userloggedin.docNumberCompany,10).subscribe(
      (data) => {
        this.solicitudes = data;
        this.loading = false;
      },
      (error) => {
        console.error('Error al cargar las solicitudes', error);
        this.loading = false;
      }
    );
  }

  showElement(process: any, index: number) {
 
    this._ROUTER.navigate(['/afiliaciones-proceso/detalle'], { state: { affiliateProcess: process } });
  }
  
    openLink() {
      this._ROUTER.navigate([
        RoutingPath.appRouting.components.affiliates_process.path,
      ]);
    }
}
